import { configs } from '@constants/configs/configs';
import { urlTools } from '@utils/tools/urlTools';

type CaseNumberObject = {
    caseNumberValue: number;
    isCaseNumberValid: boolean;
};

type LocationObject = {
    currentLocation: string;
    caseNumberObject: CaseNumberObject;
    fromCAP: string;
    fromMyApp: string;
    isSsap: boolean;
    fromHome: boolean;
    fromFlow: boolean;
    hhId: string;
};

export const useLocation = (): LocationObject => {
    const caseNumberObject = ((): CaseNumberObject => {
        const caseNumber: number = urlTools.getParameter<Number>('caseNumber');

        return {
            caseNumberValue: caseNumber,
            isCaseNumberValid: caseNumber !== null,
        };
    })();

    return {
        currentLocation: window.location.pathname,
        caseNumberObject: caseNumberObject,
        fromCAP: urlTools.getParameter<String>('fromCAP'),
        fromMyApp: urlTools.getParameter<String>('fromMyApp'),
        isSsap: window.location.pathname === configs.routes.SSAP,
        fromHome: window.location.search.includes('?fromHome=1'),
        fromFlow: window.location.search.includes('?fromFlow=1'),
        hhId: urlTools.getParameter<String>('hhId'),
    };
};
